<template>
    <div class="box">
        <div class="header">
            <Row v-if="hasPermission('addWatermark')" type="flex" class="toolbar">
                <Col span="24">
                <Button
                        ref="upload_btn"
                        @click="$router.push('detail/0')"
                        icon="md-add"
                        type="primary"
                >{{ $t('WatermarkManagement.List.button.add') }}</Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('WatermarkManagement.List.filter.watermarkName') }}</span>
                        <Input
                                v-model="filter.watermarkName"
                                class="selector"
                                size="small"
                                clearable
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li v-if="dep||(filter.selectType==3)">
                        <span>{{ $t('WatermarkManagement.List.filter.userCode') }}</span>
                        <Input
                                v-model="filter.userCode"
                                class="selector"
                                size="small"
                                clearable
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li>
                        <span>{{ $t('WatermarkManagement.List.filter.type') }}</span>
                        <Select
                                v-model="filter.watermarkType"
                                transfer
                                clearable
                                class="selector"
                                size="small"
                                :placeholder="$t('Message.placeholderSelect')"
                        >
                            <Option :value="0">{{ $t('WatermarkManagement.type.image') }}</Option>
                            <Option :value="1">{{ $t('WatermarkManagement.type.text') }}</Option>
                        </Select>
                    </li>
                    <li>
                        <DepartmentSelect filterPath="views/watermark.all.filter"></DepartmentSelect>
                    </li>
                    <li v-if="filter.selectType == 3">
                        <UserGroupSelect v-model="groupIdSelected.id" ></UserGroupSelect>
                    </li>
                </ul>
                <Button 
                    class="refresh-button" 
                    type="primary" 
                    size="small"
                    @click="() => refresh()">
                    {{ $t('Button.refresh') }}
                </Button>
            </div>
        </div>
        <PicturePreviewDialog v-model="show_viewer" :imageSrc="viewerMaterial" />
        <div ref="list" class="content">
            <ul class="list">
                <li
                        :class="p.watermarkType == Const.Watermark.Type.Image ? 'item-image' : 'item-text'"
                        :key="p.watermarkId"
                        @click="toEdit(p.watermarkId)"
                        v-for="p in list"
                ><!-- @click="$router.push('detail/'+p.watermarkId)" -->
                    <div class="item-thumb">
                        <WatermarkListPreview :data="p" />
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span class="title-tag">
                                <PrettyText :text="Const.Watermark.Type(p.watermarkType)" />
                            </span>
                            <span class="titleLink" :title="p.watermarkName"> {{p.watermarkName}}</span>
                            <span v-if="p.isDefault == 0" class="title-tag" style="background-color: yellow;margin-left: 5px">
                                {{ $t('Tag.tagDefault') }}
                            </span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('WatermarkManagement.List.list.userName') }}</span>
                                <span class="content">
                                    {{p.userName}}
                                </span>
                            </li>
                            <li v-if="p.watermarkType == Const.Watermark.Type.Image">
                                <span class="title">{{ $t('WatermarkManagement.List.list.imagePath') }}</span>
                                <span class="content">
                                    <div class="big-imge">
                                        <div class="view" @click.stop="showPreview(p)">
                                            <Icon
                                                    type="ios-search"
                                                    class="view-icon"
                                                    size="24"
                                            />
                                        </div>
                                    </div>
                                </span>
                            </li>
                            <li v-else>
                                <span class="title">{{ $t('WatermarkManagement.List.list.words') }}</span>
                                <span class="content">
                                    <span style="display: inline-block;height: 12px;width: 12px;margin-right: 5px" :style="{'background': p.fontColor, 'border': '1px solid #ADADAD', 'verticalAlign': 'middle'}"></span>
                                    <span>{{p.words}}</span>
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('WatermarkManagement.List.list.position') }}</span>
                                <span class="content">
                                    <span v-if="p.position == 1">{{ $t('WatermarkManagement.position.leftTop') }}</span>
                                    <span v-if="p.position == 2">{{ $t('WatermarkManagement.position.leftBottom') }}</span>
                                    <span v-if="p.position == 3">{{ $t('WatermarkManagement.position.rightTop') }}</span>
                                    <span v-if="p.position == 4">{{ $t('WatermarkManagement.position.rightBottom') }}</span>
                                    <span v-if="p.position == 5">{{ $t('WatermarkManagement.position.alignCenter') }}</span>
                                    <span v-if="p.position == 6">{{ $t('WatermarkManagement.position.bespread') }}</span>
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('WatermarkManagement.List.list.opacityPercent') }}</span>
                                <span class="content">
                                    <span>{{p.opacityPercent * 100}}%</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="item-op">
                        <Button
                                v-if="hasPermission('setDefaultWatermark')"
                                :class="p.isDefault == 0 ? 'default_btn download_btn' : 'download_btn'"
                                type="dashed"
                                size="large"
                                :icon="p.isDefault == 1 ? 'md-checkmark' : 'md-close'"
                                style="margin-right: 5px"
                                @click.stop="setDefault(p.watermarkId, p.isDefault)"
                        >{{ p.isDefault == 1 ? $t('Button.setDefault') : $t('Button.cancelDefault') }}</Button>
                        <Button
                                v-if="hasPermission('editWatermark')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-settings"
                                @click="e=>e.stopPropagation()"
                                :to="'detail/'+p.watermarkId"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                                v-if="hasPermission('deleteWatermark')&&(p.userId==userId)"
                                class="delete_btn"
                                type="dashed"
                                size="large"
                                icon="md-trash"
                                
                                @click.stop="remove(p.watermarkId,p.watermarkName)"
                        >{{ $t('Button.remove') }}</Button><!--&&(p.userId==userId||filter.selectType != 3) -->
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
                    transfer
            />
        </div>
    </div>
    <!-- </Scroll> -->
</template>

<script>
    import { mapState } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import apimodel from "@/model/ApiModel";
    import helper from "@/assets/helper.js";
    import PrettyText from "@/components/PrettyText";
    import PicturePreviewDialog from "@/components/PicturePreviewDialog";
    // import logger from "@/assets/log";
    import WatermarkListPreview from '@/components/WatermarkListPreview.vue';
    import DepartmentSelect from "../../../components/DepartmentSelect"
    import UserGroupSelect from "../../../components/UserGroupSelect"
    // const log = logger("views:material:all");
    import HtmlDecode from "@/plugins/htmlDecode";

    let { Const } = apimodel;

    export default {
        components: {
            UserGroupSelect,
            PrettyText,
            PicturePreviewDialog,
            WatermarkListPreview,
            DepartmentSelect
        },
        mixins: [
            {
                methods: helper
            }
        ],
        data() {
            return {
                groupIdSelected: {
                    id: this.$store.state.user.defaultSelectedUserGroup,
                    groupData: []
                },
                Const,
                // boxHeight: 300,
                show_viewer: false,
                viewerMaterial: null,
                show_download_dialog: false,
                download_dialog: {},
                loading: true,
                list: []
            };
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.watermark.all.filter;
                },
                set(v) {
                    this.$store.commit("views/watermark.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.watermark.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/watermark.all.pagination", v);
                }
            },
            ...mapState({
                uploaderLoading: state =>
                    state.uploader.UploadServer.loadingStatus == "loading",
                uploaderReady: state =>
                    state.uploader.UploadServer.loadingStatus == "done",
                uploaderResult: state => state.uploader.newMaterialStatus,
                userId: state => state.user.id,
                departmentName: state => state.department.currentName,
                departmentId: state => state.department.currentId,
                shareId: state => state.user.defaultSelectedUserGroup
            }),
            dep(){
                return this.filter.selectType == 2
            }
        },
        watch: {
            'groupIdSelected.id'(){
                this.pagination.page = 1;
                this.refresh(); 
            },
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.watermarkName'() {
                if(this.containsInvaildChar(this.filter.watermarkName)) {
                    return;
                }
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.watermarkType'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page"() {
                this.refresh();
            },
            "pagination.pageSize"() {
                this.refresh();
            },
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {
                    ;
                }
            }
        },
        methods: {
            showPreview(p) {
                this.viewerMaterial = p.imagePath;
                this.show_viewer = true;
            },
            _videoQuality(i) {
                let p = i.videoDimension
                    ? (i.videoDimension + "x").split("x")[1]
                    : "";
                p = +p ? p + "P" : "";

                return i.videoLevelName + " " + p;
            },
            toEdit(id) {
                if(this.hasPermission('editWatermark')){
                    this.$router.push("detail/"+id);
                }
            },
            /* 设置/取消默认水印 */
            async setDefault(id, isDefault){
                if(this.hasPermission('setDefaultWatermark')){
                    if (!confirm(this.$t('Message.set.confirmHead')
                            + `${ isDefault == 1 ? this.$t('Button.setDefault') : this.$t('Button.cancelDefault') }`
                            + this.$t('Message.set.watermarkConfirmTail'))) return;

                    this.loading =true;

                    try {
                        await api.call("watermark/updateDefault", {
                            watermarkId: id,
                            isDefault: isDefault == 1 ? 0 : 1,
                            userId: this.userId
                        });

                        this.$Notice.success({ title: this.$t('Message.set.success') });

                        this.refresh();
                    } catch (e) {
                        this.$Notice.error({ title: this.$t('Message.set.error'), desc: e.resultMsg });
                    }

                    this.loading = false;
                }else {
                    this.$Notice.error({ title: this.$t('Message.permission.error') });
                }
            },
            async remove(id, title) {
                if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

                this.loading = true;

                try {
                    await api.call("watermark/delete", {
                        watermarkId: id
                    });

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh(withoutLoading) {
                if(this.hasPermission('watermark')){
                    !withoutLoading && (this.loading = true);

                    try {
                        let param = extend(true, {}, this.pagination, this.filter);
                        if(this.filter.selectType == 3){
                            param.shareId = this.shareId
                        }
                        let ret = await api.call("watermark/list", param);
                        // decode name if ret.list is valid
                        if (ret.list && ret.list.length > 0) {
                            ret.list.forEach(item => {
                                item.watermarkName = HtmlDecode.d(item.watermarkName);
                            });
                        }
                        this.list = ret.list;
                        this.pagination.total = ret.total;
                    } catch (e) {                  
						this.$Notice.error({
							title: this.$t(e && e.reject ?
								'Message.permission.error' :
								'Message.callResult.retry')
						});
						this.list = [];
						this.pagination.total = 0;
                    }

                    this.loading = false;

                    !withoutLoading &&
                    this.$nextTick(() => {
                        this.$refs.list.parentElement.parentElement.parentElement.scrollTo(
                            0,
                            0
                        );
                    });
                }else {
                    this.$Notice.error({ title: this.$t('Message.permission.error') });
                }
            }
        },
        mounted() {
            //如果是 Cordova app 此页作为首页，回到本页后清楚历史记录
            if (this.isCordova() && navigator.app && navigator.app.clearCache) {
                navigator.app.clearHistory();
            }
            this.refresh();
            // window.addEventListener("resize", this.resize);
            // this.$nextTick(this.resize);
        },
        created() {},
        beforeDestroy() {
            // window.removeEventListener("resize", this.reisze);
        }
    };
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
        min-height:400px
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }

    .filter{
        // overflow:hidden;
        white-space: nowrap;
        position: relative;
    }
    .filter-expend{
        overflow: visible;
        white-space: normal;
        position: static;
        .filter-box li{
            margin:5px 5px;
        }
        .more-btn{
            position:relative
        }
    }

    .list {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .item-text {
            border-bottom: 1px solid #e9e9e8;
            height: 120px;
            padding: 15px 0;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
        }

        .item-image {
            border-bottom: 1px solid #e9e9e8;
            height: 120px;
            padding: 15px 0;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
        }

        .item-text, .item-image{
            & > * {
                height: 100%;
                display: inline-block;
                vertical-align: middle;
            }

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #e3e3e3;
                padding: 2px;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                line-height: 89px;
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    // object-fit: cover;
                    object-fit: contain;
                    background-color: #eee;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
            }
            .big-imge {
                display: inline-block;

                .view {
                    cursor: pointer;
                }
                .view:hover {
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            .item-info {
                & > .title {
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                    .video-level-tag {
                        border-radius: 2px;
                        margin-right: 5px;
                        border-bottom: 1px dashed #e3e3e3;
                        cursor: pointer;
                    }
                    .video-level-tag:after {
                        content: "、";
                    }
                    .video-level-tag:last-child:after {
                        content: "";
                    }
                }
            }
            .item-op {
                position: absolute;
                right: 0;
                height: auto;
                width: 200px;
                background: white;
                text-align: right;
                white-space: normal;
                .delete_btn2 {
                    display: none;
                }
                .default_btn{
                    background-color: yellow;
                }
            }
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    @media only screen and (max-width: 1440px) {
        .list .item .item-info > .title a {
            width: 80%;
        }
    }

    @media all and (orientation: portrait), all and (max-width: 1024px) {
        .list .item .item-op {
            background: transparent;
            .edit_btn {
                display: none;
            }
            .download_btn {
                display: none;
            }
            .delete_btn {
                display: none;
            }
            .delete_btn2 {
                display: inline-block;
            }
            bottom: 10px;
        }
        .list .item .item-thumb {
            width: 60px;
        }
        .content {
            padding: 0;
        }
    }
</style>